import React from 'react'
import Clickable from '../Clickable'
import { DepositInfoModal } from 'components/Common/DepositInfo/DepositInfoModal'
import useToggle from 'hooks/useToggle'
import PromotionLabel from 'components/Luxkit/Label/PromotionLabel'
import PayInInstalmentsMoreInfoModal from '../PayInInstalmentsInfo/PayInInstalmentsMoreInfoModal'
import LineCheckCircleIcon from 'components/Luxkit/Icons/line/LineCheckCircleIcon'
import config from 'constants/config'

interface Props {
  offerType: App.OfferType;
  depositThresholds?: App.DepositThreshold
  depositAmountPercentage: number
  depositType?: Tours.V2OfferDepositType;
  instalmentsAvailable?: boolean;
  depositAmount?: number;
}

function DepositsAvailableTag({ offerType, depositAmountPercentage, depositThresholds, depositType, instalmentsAvailable, depositAmount }: Props) {
  const [isPolicyOpen, , openPolicy, closePolicy] = useToggle()
  return (
    <>
      {config.DEPOSITS_TAGS_ENABLED && <Clickable onClick={openPolicy}>
        <PromotionLabel variant="default" icon={<LineCheckCircleIcon />}>
          Deposits available
        </PromotionLabel>
      </Clickable>}
      {instalmentsAvailable &&
        <PayInInstalmentsMoreInfoModal
          isPolicyOpen={isPolicyOpen}
          closePolicy={closePolicy}
          depositPercentage={depositAmountPercentage}/>
      }
      {!instalmentsAvailable &&
        <DepositInfoModal
          isModalOpen={isPolicyOpen}
          offerType={offerType}
          onCloseModal={closePolicy}
          depositAmountPercentage={depositAmountPercentage}
          depositThresholds={depositThresholds}
          depositType={depositType}
          depositAmount={depositAmount}
        />
      }
    </>
  )
}

export default DepositsAvailableTag
